'use strict';
import $ from 'jquery';

export default class SmoothScroll {
  static init() {
    $('a[href^="#"]:not([data-toggle]):not(.author-wrapp):not(.no-smooth-scroll):not(.m167-tab)').each((index, el) => {
      new SmoothScroll($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    this.el.on('click', this.onClick.bind(this));
  }

  onClick(e) {
    const self = this;
    const href = $(e.currentTarget).attr('href');
    if ('#' !== href && $(href).is(':visible')) {
      let offset = $(href).offset().top - $('header').outerHeight();
      if ($('#wpadminbar').length)
        offset -= $('#wpadminbar').height();
      $('html,body').animate(
        {
          scrollTop: offset,
        }, {
        duration: 500,
        easing: 'swing',
        complete: () => {
          self.el.trigger('scrollComplete');
        }
      });
    }
  }
}
